import { Link, createFileRoute } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { PageHeader } from '@/components/PageHeader';
import { UserList } from '@/components/community/UserRow';
import { useFollowing } from '@/lib/queries/users';

export const Route = createFileRoute('/_app/community/u/$handle/following')({
  component: FollowingPage,
});

/** A quién sigue esa cuenta, con el botón de seguir en cada fila. */
function FollowingPage() {
  const { handle } = Route.useParams();
  const query = useFollowing(handle);
  const users = query.data?.pages.flatMap((page) => page.items) ?? [];

  return (
    <>
      <PageHeader
        title="Siguiendo"
        subtitle={`@${handle}`}
        action={
          <Link
            to="/community/u/$handle"
            params={{ handle }}
            search={{}}
            aria-label="Volver al perfil"
            className="flex size-11 items-center justify-center rounded-xl border border-line text-ink-muted transition-colors hover:bg-surface-raised active:bg-surface-raised"
          >
            <ArrowLeft className="size-5" aria-hidden="true" />
          </Link>
        }
      />

      <UserList
        users={users}
        isPending={query.isPending}
        isError={query.isError}
        error={query.error}
        onRetry={() => void query.refetch()}
        hasNextPage={query.hasNextPage}
        isFetchingNextPage={query.isFetchingNextPage}
        onLoadMore={() => void query.fetchNextPage()}
        errorTitle="No hemos podido cargar la lista"
        empty={
          <p className="rounded-2xl border border-dashed border-line bg-surface-raised px-5 py-10 text-center text-sm text-ink-muted">
            Esta cuenta todavía no sigue a nadie.
          </p>
        }
      />
    </>
  );
}
